// Campus photo for /colleges/george-washington-university: CC BY-SA 3.0, by Another Believer, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_Yard%2C_George_Washington_University%2C_2012.JPG), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/george-washington-university/; credited under the photo.
const photo = {
    "slug": "george-washington-university",
    "alt": "University Yard with its statue of George Washington at George Washington University in Washington, DC",
    "src": "/colleges/george-washington-university/campus-1600.webp",
    "srcSmall": "/colleges/george-washington-university/campus-800.webp",
    "srcMid": "/colleges/george-washington-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/george-washington-university/og.jpg",
    "title": "University Yard, George Washington University, 2012",
    "author": "Another Believer",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_Yard%2C_George_Washington_University%2C_2012.JPG",
    "read": "2026-09-30"
};

export default photo;
